<template>
  <div
    :class="[
      $style.wrapper,
      {[$style.mobileSeeThroughButton]: this.isMobile},
      {[$style.top]: this.isTop},
  ]"
  >
    <span :class="$style.text">{{ text }}</span>
  </div>
</template>

<script>
import isMobileMixin from "../plugins/isMobileMixin";

export default {
  props: ["text"],
  mixins: [isMobileMixin],
  data() {
    return {
      isTop: false
    };
  },
  watch: {
    $route(to, from) {
      if (!this.isMobile) return;

      if (to.path !== "/") {
        this.top = true;
        // this.putButtonAtTopMobile();
      } else {
        this.top = false;
        // this.putButtonAtBottomMobile();
      }
    }
  },
  mounted() {
    if (this.isMobile) {
      this.$bus.$on(
        "hide-win-button-for-transition",
        this.handleHideButtonForTransition
      );

      // this.$bus.$on("show-win-button", this.handleShowWinButtonMobile);

      if (this.$route.path !== "/") {
        this.top = true;
        // this.putButtonAtTopMobile();
      } else {
        this.top = false;
        // this.putButtonAtBottomMobile();
      }
    }
  },
  methods: {
    putButtonAtBottomMobile() {
      TweenMax.set(`.${this.$style.wrapper}`, {
        clearProps: "all"
      });

      // TweenMax.set(`.${this.$style.wrapper}`, {
      //   position: "absolute",
      //   left: "50%",
      //   top: "50%",
      //   bottom: "auto",
      //   marginRight: 0,
      //   marginTop: 0,
      //   x: "-50%",
      //   y: "-50%"
      // });
    },

    putButtonInMiddleMobile() {
      TweenMax.set(`.${this.$style.wrapper}`, {
        clearProps: "all"
      });

      TweenMax.set(`.${this.$style.wrapper}`, {
        position: "absolute",
        left: "50%",
        top: "50%",
        bottom: "auto",
        marginRight: 0,
        marginTop: 0,
        x: "-50%",
        y: "-50%"
      });
    },
    putButtonAtTopMobile() {
      console.log("putButtonAtTop");
      TweenMax.set(`.${this.$style.wrapper}`, {
        clearProps: "all"
      });

      TweenMax.set(`.${this.$style.wrapper}`, {
        position: "absolute",
        right: "25px",
        top: "25px",
        left: "auto",
        bottom: "auto",
        paddingLeft: "10px",
        paddingRight: "10px",
        x: 0,
        fontSize: "16px",
        opacity: 0
      });

      // fade in
      TweenMax.to(`.${this.$style.wrapper}`, 0.5, {
        delay: 1,
        opacity: 1
      });
    },
    handleHideButtonForTransition() {
      // fade out element
      TweenMax.to(`.${this.$style.wrapper}`, 0.5, {
        opacity: 0,
        pointerEvents: "none"
      });
    }
  }
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  max-width: 300px;
  font-size: 14px;

  padding-top: 15px;
  padding-bottom: 20px;
  padding-left: 25px;
  padding-right: 25px;

  border-radius: 30px;

  background-color: $jaffa;
  transition: color 0.3s;

  font-weight: bold;
  line-height: 1.333em;
  text-align: center;

  color: white;

  cursor: pointer;

  @include medium {
    font-size: 16px;
  }

  @include large {
    font-size: 18px;
  }

  &:before {
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 100%;
    margin: -15px 0 0 1px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: darken($jaffa, 15%);
    transform-origin: 100% 50%;
    transition: transform 0.3s, opacity 0.3s;
    content: "";
  }

  &:hover,
  &:focus {
    &:before {
      transform: scale3d(20, 20, 1);
    }
  }
}

.mobile-see-through-button {
  margin: 0;
  // white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/components/SeeThroughButton.vue